import React from 'react';
import PropTypes from 'prop-types';

import { pxScoresPropType, stylePropType } from 'src/PropTypes';
import { Style1 as Style } from 'src/styles';

import HeatmapVariant from './heatmap_variant';
import RadarVariant from './radar_variant';

function Segments({ heading, objects, style, styleOverride, minW, minH, onThemeChange, variant }) {
	return variant === 'heatmap' ? (
		<HeatmapVariant
			heading={heading}
			objects={objects}
			style={style}
			styleOverride={styleOverride}
			minW={minW}
			minH={minH}
			onThemeChange={(...params) => onThemeChange(...params)}
		/>
	) : (
		<RadarVariant
			heading={heading}
			objects={objects}
			style={style}
			styleOverride={styleOverride}
			minW={minW}
			minH={minH}
			onThemeChange={(...params) => onThemeChange(...params)}
		/>
	);
}

Segments.propTypes = {
	heading: PropTypes.string,
	objects: PropTypes.arrayOf(
		PropTypes.shape({
			name: PropTypes.string,
			pxScores: pxScoresPropType,
		})
	).isRequired,
	style: stylePropType,
	styleOverride: PropTypes.shape({}),
	minH: PropTypes.string,
	minW: PropTypes.string,
	variant: PropTypes.string,
	onThemeChange: PropTypes.func,
};

Segments.defaultProps = {
	heading: 'Facets Comparison',
	style: Style,
	styleOverride: {
		background: Style.global.backgroundColor,
	},
	minH: '100vh',
	minW: '100vw',
	variant: 'heatmap',
	onThemeChange: () => null,
};

export default Segments;
